document.addEventListener('DOMContentLoaded', function () {
  initTooltips();
});

function initTooltips() {
  if (typeof tippy !== 'undefined') {
    tippy('[data-tooltip]', {
      content(reference) {
        return reference.getAttribute('data-tooltip');
      },
      allowHTML: true,
      interactive: true,
      appendTo: () => document.body
    });
  }
}

function destroyTooltips() {
  tippy('[data-tooltip]').forEach((instance) => instance.destroy());
}

function reinitTooltips() {
  destroyTooltips();
  initTooltips();
}

document.addEventListener('reinit-tooltips', () => {
  reinitTooltips();
});
